import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import useHttpStatus from '~/commons/hooks/useHttpStatus';
import PageHttp from '~/commons/components/PageHttp.jsx';
import Header from '../../layout/Header.jsx';
import FormOrder from '../../forms/FormOrder.jsx';

const PageOrder = () => {
  const { _id } = useParams();
  const [res, req] = useHttpStatus();
  const [resDDL, reqDDL] = useHttpStatus();
  const [resSync, reqSync] = useHttpStatus();
  const [, reqCR] = useHttpStatus();

  useEffect(() => {
    if (_id !== 'new') {
      req({ url: `/api/core/orders/${_id}` });
    }
    reqCR({ url: `/api/core/access-logs/latest/${_id}/Order ERP: Sync` });
    reqDDL({ url: '/api/core/users/self/order' });
  }, [_id]);

  const sync = async () => {
    await reqSync({
      method: 'POST',
      url: `/api/core/orders/toErp/${_id}`,
    });
  };

  const breadcrumb = _id === 'self' ? [] : [{ to: '../', children: 'Orders' }];

  return _id === 'new' ? (
    <PageHttp res={resDDL}>
      {(doc) => (
        <>
          <Header breadcrumb={breadcrumb}>New orders</Header>
          <FormOrder services={doc.services} sales={doc.departments} />
        </>
      )}
    </PageHttp>
  ) : (
    <PageHttp res={[res, resDDL]}>
      {([order, ddl]) => (
        <>
          <Header breadcrumb={breadcrumb}>Edit</Header>
          <FormOrder
            order={order}
            services={ddl.services}
            sales={ddl.departments}
            syncOrder={{ resSync, sync }}
          />
        </>
      )}
    </PageHttp>
  );
};

export default PageOrder;
